import type { AnchorHTMLAttributes, FC, RefAttributes } from 'react';

export interface AnchorComponent
  extends FC<AnchorHTMLAttributes<HTMLAnchorElement> & RefAttributes<HTMLAnchorElement>> {}
